/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetClientEmailOptOutQueryVariables = Types.Exact<{
  [key: string]: never;
}>;
export type GetClientEmailOptOutQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    id: string;
    email: string;
    notificationPreference: {
      __typename?: "NotificationPreference";
      emailOptOut?: boolean | null;
    };
    notificationSettings: {
      __typename?: "NotificationSettings";
      secondaryProfileTextTitle: {
        __typename?: "I18nCopy";
        key: string;
        text: string;
      };
      secondaryProfileTextDescription: {
        __typename?: "I18nCopy";
        key: string;
        text: string;
      };
      email: {
        __typename?: "NotificationSettingsEmail";
        allowForAllHouseholdToggleText?: {
          __typename?: "I18nCopy";
          key: string;
          text: string;
        } | null;
        header: {
          __typename?: "NotificationSettingsHeader";
          title: {
            __typename?: "I18nCopy";
            key: string;
            text: string;
          };
          description?: {
            __typename?: "I18nCopy";
            key: string;
            text: string;
          } | null;
        };
        householdPromotionalEmailsTitle: {
          __typename?: "I18nCopy";
          key: string;
          text: string;
        };
        householdPromotionalEmailsDescription: {
          __typename?: "I18nCopy";
          key: string;
          text: string;
        };
        preferences: Array<{
          __typename?: "NotificationSettingsPreference";
          channel: string;
          communicationId?: string | null;
          description: string;
          enabled: boolean;
          title: string;
          type: string;
        }>;
      };
      sms: {
        __typename?: "NotificationSettingsSms";
        header: {
          __typename?: "NotificationSettingsHeader";
          title: {
            __typename?: "I18nCopy";
            key: string;
            text: string;
          };
          description?: {
            __typename?: "I18nCopy";
            key: string;
            text: string;
          } | null;
        };
        smsSignUpButtonTitle?: {
          __typename?: "I18nCopy";
          key: string;
          text: string;
        } | null;
        preferences: Array<{
          __typename?: "NotificationSettingsPreference";
          channel: string;
          communicationId?: string | null;
          description: string;
          enabled: boolean;
          title: string;
          type: string;
        }>;
      };
    };
    household?: {
      __typename?: "Household";
      primaryClientId: string;
      members: Array<{
        __typename?: "HouseholdMember";
        businessLine: Types.BusinessLine;
        externalId: string;
        firstName: string;
        iconColor: string;
        id: string;
        lastName?: string | null;
        name: string;
        textColor: Types.HouseholdTextColorTheme;
      }>;
    } | null;
  } | null;
};
export const GetClientEmailOptOutDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "getClientEmailOptOut"
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "client"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "email"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "notificationPreference"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "emailOptOut"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "notificationSettings"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "secondaryProfileTextTitle"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "key"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "text"
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "secondaryProfileTextDescription"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "key"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "text"
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "email"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "allowForAllHouseholdToggleText"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "key"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "text"
                        }
                      }]
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "header"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "title"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "key"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "text"
                            }
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "description"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "key"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "text"
                            }
                          }]
                        }
                      }]
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "householdPromotionalEmailsTitle"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "key"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "text"
                        }
                      }]
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "householdPromotionalEmailsDescription"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "key"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "text"
                        }
                      }]
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "preferences"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "channel"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "communicationId"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "description"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "enabled"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "title"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "type"
                        }
                      }]
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "sms"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "header"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "title"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "key"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "text"
                            }
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "description"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "key"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "text"
                            }
                          }]
                        }
                      }]
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "smsSignUpButtonTitle"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "key"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "text"
                        }
                      }]
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "preferences"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "channel"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "communicationId"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "description"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "enabled"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "title"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "type"
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "household"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "members"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "businessLine"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "externalId"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "firstName"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "iconColor"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "id"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "lastName"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "name"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "textColor"
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "primaryClientId"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;

/**
 * __useGetClientEmailOptOutQuery__
 *
 * To run a query within a React component, call `useGetClientEmailOptOutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientEmailOptOutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientEmailOptOutQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientEmailOptOutQuery(baseOptions?: Apollo.QueryHookOptions<GetClientEmailOptOutQuery, GetClientEmailOptOutQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetClientEmailOptOutQuery, GetClientEmailOptOutQueryVariables>(GetClientEmailOptOutDocument, options);
}
export function useGetClientEmailOptOutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientEmailOptOutQuery, GetClientEmailOptOutQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetClientEmailOptOutQuery, GetClientEmailOptOutQueryVariables>(GetClientEmailOptOutDocument, options);
}
export type GetClientEmailOptOutQueryHookResult = ReturnType<typeof useGetClientEmailOptOutQuery>;
export type GetClientEmailOptOutLazyQueryHookResult = ReturnType<typeof useGetClientEmailOptOutLazyQuery>;
export type GetClientEmailOptOutQueryResult = Apollo.QueryResult<GetClientEmailOptOutQuery, GetClientEmailOptOutQueryVariables>;